import { Component, Injector, Input, OnInit, Optional } from '@angular/core';
import { UserLoginHistory, UserLoginHistoryService } from '@mango/authentication';
import { createColumnDefinitions, Filter, PagedCollectionComponent, SearchableType, ColumnDefinition } from '@mango/core';
import { User } from 'src/app/user/user';

@Component({
    selector: 'user-login-history-collection',
    templateUrl: 'login-history-collection.component.html',
})

export class UserLoginHistoryCollectionComponent extends PagedCollectionComponent<UserLoginHistory> {

    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<UserLoginHistory>([
        { prop: 'date', searchable: SearchableType.Date },
        { prop: 'ipAddress', searchable: SearchableType.String },
    ]);

    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: UserLoginHistoryService, @Optional() injector: Injector, @Optional() protected filter: Filter<UserLoginHistory>) {
        super('/userLoginHistories', injector, UserLoginHistory);

        if (!this.filter) {
            this.filter = new Filter<UserLoginHistory>();
        }

        this.initInput('user', this.filterBuilder.equal(x => x.user.id));
    }

    @Input() set user(val: User) {
        this.handleInput('user', val.id);
    }

    ngOnInit() {
        super.ngOnInit();
    }
}
